import { Link } from "react-router-dom";
import { DollarSign } from "lucide-react";
import { usePricingSetup } from "@/components/dealer/PricingGate";

export const PricingSetupTask = () => {
  const { loaded, complete, priced } = usePricingSetup();
  if (!loaded || complete) return null;
  return (
    <Link to="/dealer/pricing/setup" className="mt-6 flex items-start gap-3 rounded-lg border border-border bg-sand/50 p-4 transition-colors hover:bg-sand" data-testid="pricing-setup-task">
      <DollarSign className="mt-0.5 h-5 w-5 text-terracotta" />
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-terracotta">Optional — for client proposals</p>
        <p className="mt-1 font-medium text-charcoal">Set up your selling prices</p>
        <p className="mt-0.5 text-xs text-muted-foreground">Enter one price per square foot for 4×4 Zellige, 2×6 Bejmat and 2×2 Mdebdeb — {priced} of 3 done. Ordering, samples, reservations, projects and sourcing work without them; they are only used for the prices your clients see in proposals and Customer View.</p>
      </div>
    </Link>
  );
};
